import { commitMutation, graphql } from "react-relay";

import { environment } from "~/models";

import type { EmbedNodeAttributes } from "./prose/plugins/integrations/helpers";

import type { blockInserterAddBlocksMutation as MutationType } from "~/__generated__/blockInserterAddBlocksMutation.graphql";

const addBlocksMutation = graphql`
	mutation blockInserterAddBlocksMutation($input: AddBlocksInput!) {
		addBlocks(input: $input) {
			ok
		}
	}
`;

export const insertLoomVideo = (noteId: string, attrs: EmbedNodeAttributes) => {
	const videoBlockData = {
		text: null,
		type: "embed",
		attrs,
	};

	commitMutation<MutationType>(environment, {
		mutation: addBlocksMutation,
		variables: {
			input: {
				noteId,
				blocksData: [videoBlockData],
			},
		},
	});
};
